/* eslint-disable no-self-compare */
const isnan = obj => obj !== obj

export default isnan
